import * as React from 'react';

import { WrappedFC } from '../shared/types';
import { Button } from './button';

interface Props {
  /** 表示するコンポーネントの種類 */
  type: 'country' | 'language' | 'region' | 'purchase';
  /** アイテムリスト */
  items: {
    id: string;
    text: string;
    select: true | false;
    onClick: (key: string) => void;
  }[];
  /** 選択言語 */
  selectedLanguage: string;
  /** 選択地域 */
  selectedRegion: string;
  /** 選択国 */
  selectedCountry: string;
  /** 選択契約中・購入履歴 */
  selectedPurchase: string;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';
const CLASS_NAME_MAPPING = {
  country: 'countries clearfix',
  language: 'languages clearfix',
  region: 'regions clearfix',
  purchase: 'purchases clearfix'
};

/**
 * アイテムコンポーネント
 */
export const Items: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  items,
  selectedLanguage,
  selectedRegion,
  selectedCountry,
  selectedPurchase,
  'data-test': dataTest,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _clsName = CLASS_NAME_MAPPING[type];
  // リスト部に表示するComponentをメモライズ
  const listComponent = React.useMemo(() => {
    return items.map((item, index) => (
      <Button
        num={index}
        type={type}
        select={item.select}
        data-test={`${dataTest}-${item.id}`}
        onClick={() => {
          item.onClick(item.id);
        }}
        key={`${item.id}`}
      >
        {item.text}
      </Button>
    ));
  }, [selectedLanguage, selectedRegion, selectedCountry, selectedPurchase]);

  return (
    <Element {...props} className={_clsName} data-test={dataTest}>
      {listComponent}
    </Element>
  );
};
Items.displayName = 'Items';
